import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

// Usuarios & Restablecer contraseña
import { UsuariosService } from '../services/usuarios.service';
import swal from 'sweetalert';
// Usuarios & Restablecer contraseña


@Component({
  selector: 'app-forgetpassgord',
  templateUrl: './forgetpassgord.component.html',
  styleUrls: ['./forgetpassgord.component.css']
})
export class ForgetpassgordComponent implements OnInit {

  constructor(
    private router: Router,
    private activate: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private usuarios: UsuariosService
  ) { }

  // Variables
  public error: string;
  model:any={};

  ngOnInit() {
    this.spinner.show();
    var materialInputs = $('input.input-material');
    // activate labels for prefilled values
    materialInputs.filter(function() { return $(this).val() !== ""; }).siblings('.label-material').addClass('active');
    // move label on focus
    materialInputs.on('focus', function () {
      $(this).siblings('.label-material').addClass('active');
    });
    // remove/keep label on blur
    materialInputs.on('blur', function () {
      $(this).siblings('.label-material').removeClass('active');
      if ($(this).val() !== '') {
        $(this).siblings('.label-material').addClass('active');
      } else {
        $(this).siblings('.label-material').removeClass('active');
      }
    });
    /**
     * Valida si el token es valido, viene en la url
     * @param user Clave de usuario
     * @param nombre Nombre del usuario
     * @param token Token de la url
     * @param reseteopass Si ya ha realizado el cambio forzoso
    **/
    this.usuarios.revisarToken(this.activate.snapshot.paramMap.get('token')).subscribe(
      result => {
        if (result.error==0) {
          this.model={
            'newPass':'',
            'confirmarPass':'',
            'uid': result.user,
            'nombre': result.nombre,
            'token':result.token,
            'reseteopass':result.reseteopass
          };
        }else{
          swal({
            title: result.message,
            icon: "error",
          });
          this.router.navigate(['login']);
        }
        this.spinner.hide();
      },
      err => { console.log(err) }
    );
  }
  /**
     * Valida la nueva contraseña ingresada
     * Envia datos a Usuario service solicitudCambioPass()
     * @param newPass Nueva contraseña
     * @param confirmarPass confirmacion de nueva contraseña
     * @param token Token de la url
     * @param reseteopass Si ya ha realizado el cambio forzoso
    **/
  resetearPass(){
    console.log(this.model);
    var errorPass=null, errorConf=null;
    if ( this.model.newPass.length==0 || this.model.newPass=='' ){
      errorPass="Contraseña es obligatorio.";
    }else if (this.model.newPass.length<8) {
      errorPass="La contraseña debe ser minimo 8 caracteres.";
    }
    if ( this.model.confirmarPass.length==0 || this.model.confirmarPass=='' ){
      errorConf="Confirmar contraseña es obligatorio.";
    } else if (this.model.confirmarPass!==this.model.newPass) {
      errorConf="No coinciden las contraseñas.";
    }
    if (errorPass==null && errorConf==null) {
      swal({
        title: "¡Nueva Contraseña!",
        text: "Se actualizara su contraseña por el dato agregado \n¿Estas seguro de su contraseña?",
        icon: "warning",
        buttons: ["Cancelar", "Continuar"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          swal({
            text: "Introduzca la palabra 'ACTUALIZAR' para continuar",
            content: "input",
             // @ts-ignore
             button: {
              text: "Continuar",
              closeModal: false
            }
          }).then(value=>{
            if(!value) throw null;
            if (value !=='ACTUALIZAR') {
              swal("¡Error!", "No se ha escrito 'ACTUALIZAR' correctamente", "error");
            } else {
              this.usuarios.solicitudCambioPass(this.model.newPass,this.model.uid,this.model.token,parseInt(this.model.reseteopass)).subscribe(data => {
                if(data.reseteopass['affectedRows']==1 && data.reseteopass['warningCount']==0 && data.usuarios['affectedRows']==1 && data.usuarios['warningCount']==0){
                  swal("Se actualizo correctamente", {
                    icon: "success",
                    // @ts-ignore
                    buttons: {
                      cancel: false,
                      confirm: false,
                    },
                    timer: 2000,
                  });
                  this.router.navigate(['login']);
                } else {
                  swal({
                    title: "Hubo un error al actualizar la contraseña.",
                    icon: "error",
                  });
                }
              });
            }
          }).catch(error =>{
            if (error) {
              swal("¡Oh no!", "Ocurrio un error intente nuevamente.", "error");
            } else {
              swal.stopLoading();
              // @ts-ignore
              swal.close();
            }
          });
        }
      });
    } else {
      this.error=( (errorPass==null)?'' : errorPass )+'\n '+( (errorConf==null)?'' : errorConf );
    }
  }

}